<template>
    <div class="add-report">
        <form @submit.prevent="save()" autocomplete="off">
            <TextInput
                    :formInputResetFlag="formInputResetFlag"
                    :id="'on_date'"
                    :value="on_date"
                    :required=true
                    label="Dzień"
                    type="date"
                    v-model="on_date"
            />
            <TextInput
                    :formInputResetFlag="formInputResetFlag"
                    :id="'from_hour'"
                    :value="from_hour"
                    :required=true
                    label="Od"
                    type="time"
                    v-model="from_hour"
            />
            <TextInput
                    :formInputResetFlag="formInputResetFlag"
                    :id="'to_hour'"
                    :value="to_hour"
                    :required=true
                    label="Do"
                    type="time"
                    v-model="to_hour"
            />
            <SelectOption
                    :formInputResetFlag="formInputResetFlag"
                    :options="placeChoices"
                    :required=true
                    label="Miejsce"
                    id="place"
                    v-model="place"
            />
            <button class="btn btn-orange float-right"
                    type="submit">
                Dodaj raport
            </button>
        </form>
    </div>
</template>

<script>
    import {backend} from "../../backend";
    import Constants from '../../constants.js';
    import TextInput from "../TextInput.vue";
    import SelectOption from "../SelectOption.vue";

    export default {
        name: 'AddReport',
        components: {
            TextInput,
            SelectOption
        },
        data() {
            return {
                on_date: '',
                from_hour: '',
                to_hour: '',
                place: '',
                places: [],
                formInputResetFlag: false,
            }
        },
        created() {
            this.init();
        },
        computed: {
            placeChoices: function () {
                return this.places.map((el) => el.name);
            }
        },
        methods: {
            init: function () {
                this.on_date = moment().format('YYYY-MM-DD');
                this.from_hour = Constants.get('DEFAULT_REPORT_FROM_TIME');
                this.to_hour = Constants.get('DEFAULT_REPORT_TO_TIME');
                this.$store.dispatch('ia/places')
                    .then((data) => {
                        this.places = data;
                        this.place = this.places[0]['name'];
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać listy miejsc.', color: 'danger'});
                    });
                this.formInputResetFlag = !this.formInputResetFlag;
            },
            save: function () {
                if (this.from_hour >= this.to_hour) {
                    this.$vs.notify({
                        text: 'Czas rozpoczęcia musi być wcześniejszy od czasu zakończenia.',
                        color: 'danger'
                    });
                } else if (moment(this.on_date) > moment().startOf('day')) {
                    this.$vs.notify({
                        text: 'Nie można utworzyć raportu na przyszły dzień.',
                        color: 'danger'
                    });
                } else {
                    this.sendReport();
                }
            },
            sendReport: function () {
                backend.createReport({
                    'on_date': new Date(this.on_date),
                    'from_hour': this.timeToMinutes(this.from_hour),
                    'to_hour': this.timeToMinutes(this.to_hour),
                    'place': this.getPlaceId(),
                })
                    .then(() => {
                        this.$emit('created');
                        this.$vs.notify({text: 'Utworzono.', color: 'success'});
                    })
                    .catch((error) => {
                        this.$vs.notify({
                            text: error.response.data['msg'] || 'Nie udało się utworzyć raportu.',
                            color: 'danger',
                        });
                    });
            },
            timeToMinutes: function (time) {
                time = time.split(':').map((x) => parseInt(x));
                return time[0] * 60 + time[1];
            },
            getPlaceId: function () {
                return parseInt(this.places.find((x) => x.name === this.place)['id']);
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// AddReport.vue?15286e4c